import { render, staticRenderFns } from "./ViewBirchDetails.html?vue&type=template&id=69c50c16&scoped=true&external"
import script from "./ViewBirchDetails.js?vue&type=script&lang=js&external"
export * from "./ViewBirchDetails.js?vue&type=script&lang=js&external"
import style0 from "./ViewBirchDetails.scss?vue&type=style&index=0&id=69c50c16&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c50c16",
  null
  
)

export default component.exports